export const SET_LOGGED_IN = 'SET_LOGGED_IN'
export const SET_USER = 'SET_USER'
export const SET_USER_TOKEN = 'SET_USER_TOKEN'
export const SET_ORG = 'SET_ORG'
